import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export interface CreateClassroomRoyalePayload {
  meetingId: string;
  occurenceId: string;
  roomId: string;
  shareCode: string;
  /** Royale settings (object or pre-stringified JSON) — stored for history. */
  settings?: unknown;
  /** Lobby expiry as epoch ms (the Redis lobby expiry); gates the Join banner. */
  expiresAt?: number;
}

export interface CreateClassroomRoyaleResponse {
  success: boolean;
  room_id?: string;
  share_code?: string;
  expires_at?: string;
  students_notified?: number;
  error?: string;
}

export default function useCreateClassroomRoyaleApi(
  handleOnSuccess?: (data: CreateClassroomRoyaleResponse) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<
  CreateClassroomRoyaleResponse,
  unknown,
  CreateClassroomRoyalePayload
> {
  return useMutation<
    CreateClassroomRoyaleResponse,
    unknown,
    CreateClassroomRoyalePayload
  >(
    async (payload: CreateClassroomRoyalePayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/create_classroom_puzzle_royale/',
        payload,
      );
      return response.data;
    },
    {
      onSuccess: (data: CreateClassroomRoyaleResponse) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to create classroom puzzle royale:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
